const AnnulmentPage = () => {
  return <h1>Annulment Page</h1>;
};
export default AnnulmentPage;
